import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ouu0s1k: FaireProductEntity = {
  token: "p_9ouu0s1k",
  type: "product",
  name: "Coastal Calm\u00ae Bar Soap",
  brandName: "Old Whaling Company",
  imageUrl:
    "https://cdn.faire.com/fastly/41f1e9857d52f0fe071e5c89bd6a0a970fc9b67c3f83aabe518bd32355e185c2.jpeg",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fc9c7ff4b6209cab284c33a775824ec07b2ff9733139e6307ca5371e7bd00788.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
